<template>
  <div class="h-screen w-screen">
    <div
      class="absolute w-screen h-screen bg-gray-400 flex flex-col items-center justify-evenly"
      style="z-index: 51;"
      v-if="modal.show"
    >
      <span class="text-red-600 text-lg">{{ modal.auxText }}</span>
      <img src="../assets/logo.png" alt="" />
      <div class="text-center flex flex-col">
        <span>{{ modal.text }}</span>
        <FileLoader
          class="m-2 p-2 border border-pink-400 bg-pink-500 hover:bg-pink-400 cursor-pointer text-white rounded"
          @load="loadSvgFromFile"
          @loading="modal.text = 'Loading...'"
        >
        </FileLoader>
      </div>
    </div>
    <TopBar @fileLoad="loadSvgFromBar"> </TopBar>
    <div id="content" class="w-full h-full flex flex-row">
      <div
        class="w-1/4 max-h-full flex flex-col overflow-y-auto bg-gray-100 border-r-2 border-gray-400 p-3"
      >
        <div class="mb-2 flex flex-row justify-between items-center">
          <span>Labels</span>
          <div class="flex h-8">
            <div class="dropdown inline-block">
              <button
                class="
                border
                border-blue-700
                bg-blue-400
                hover:bg-blue-500
                rounded
                text-white
                text-center
                text-lg
                pb-1
                pt-1
                pr-1
                pl-1
                mr-1
                h-full
              "
              >
                <TypographyIcon size="18" />
              </button>
              <div class="relative">
                <ul class="dropdown-menu absolute hidden text-gray-700 pt-1">
                  <li
                    class="w-full"
                    style="margin: 0 !important"
                    v-for="(font, index) in listFonts"
                    :key="index"
                  >
                    <a
                      class="rounded-b bg-gray-200 hover:bg-gray-400 py-0 px-4 block cursor-pointer link-ellipsis"
                      :style="`font-family: ${font}`"
                      @click="changeFont(font)"
                      >{{ font.replaceAll('"', '') }}</a
                    >
                  </li>
                </ul>
              </div>
            </div>
            <button
              class="
                border
                border-pink-700
                bg-pink-400
                hover:bg-pink-500
                rounded
                text-white
                text-center
                text-xs
                pr-2
                pl-2
                mr-1
              "
              @click="shrinkText()"
            >
              A
            </button>
            <button
              class="
                border
                border-pink-700
                bg-pink-400
                hover:bg-pink-500
                rounded
                text-white
                text-center
                text-lg
                pr-2
                pl-2
                mr-1
              "
              @click="enlargeText()"
            >
              A
            </button>
            <button
              class="
                border
                border-teal-700
                bg-teal-400
                hover:bg-teal-500
                rounded
                text-white
                text-center
                pt-1
                pr-2
                pl-2
                mr-1
              "
              @click="addNewLabel()"
            >
              +
            </button>
          </div>
        </div>
        <div class="mb-3 w-full">
          <input
            type="text"
            placeholder="Search a label"
            class="rounded pl-2 pt-1 pb-1 text-sm w-full mr-2 border border-pink-400 focus:border-pink-300 bg-pink-100"
            v-model="searchTerm"
          />
        </div>
        <div class="flex-grow overflow-y-auto pr-1 pb-1 mb-3">
          <div
            v-for="(elem, index) in displayedTextElements"
            v-bind:key="index"
          >
            <div v-if="elem.text" class="flex flex-row h-8 mt-1 w-full">
              <input
                class="focus:border-blue-300 focus:border-2 focus:bg-blue-100 rounded pl-2 ml-1 min-h-8 text-sm mr-1 min-w-0 flex-grow"
                v-model="elem.text"
                @focus="elem.highlighted = true"
                @blur="elem.highlighted = false"
                :ref="`input${index}`"
              />
              <div class="flex flex-row">
                <div class="dropdown inline-block">
                  <button
                    class="
                border
                border-blue-700
                bg-blue-400
                hover:bg-blue-500
                rounded
                text-white
                text-center
                text-lg
                height-buttons
                pr-1
                pl-1
                mr-1
              "
                  >
                    <TypographyIcon size="18" />
                  </button>
                  <div class="relative">
                    <ul
                      class="dropdown-menu absolute hidden text-gray-700 pt-1"
                    >
                      <li
                        class="w-full"
                        style="margin: 0 !important"
                        v-for="(font, index) in listFonts"
                        :key="index"
                      >
                        <a
                          class="rounded-b bg-gray-200 hover:bg-gray-400 py-0 px-4 block cursor-pointer link-ellipsis"
                          :style="`font-family: ${font}`"
                          @click="changeFont(font, elem.index)"
                          >{{ font.replaceAll('"', '') }}</a
                        >
                      </li>
                    </ul>
                  </div>
                </div>
                <button
                  class="
                  border
                  border-pink-700
                  bg-pink-400
                  hover:bg-pink-500
                  rounded
                  text-white
                  text-center
                  text-xs
                  height-buttons
                  pr-2
                  pl-2
                  mr-1
                "
                  @click="shrinkText(elem.index)"
                >
                  A
                </button>
                <button
                  class="
                border
                border-pink-700
                bg-pink-400
                hover:bg-pink-500
                rounded
                text-white
                text-center
                text-lg
                height-buttons
                pr-2
                pl-2
                mr-1
              "
                  @click="enlargeText(elem.index)"
                >
                  A
                </button>
                <button
                  class="
                  border
                  border-gray-500
                  bg-gray-500
                  hover:bg-gray-600
                  rounded
                  text-white
                  text-center
                  text-lg
                  height-buttons
                  pr-1
                  pl-1
                  mr-1
                "
                  @click="deleteText(elem.index)"
                >
                  <TrashIcon size="18" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="w-4/5 h-full flex overflow-x-auto overflow-y-auto items-center justify-center"
      >
        <div id="inputsvg" class="border border-gray-500 w-full h-full">
          <EditableSvg
            :template="this.svg.content"
            :elements="this.svg.textElements"
            @labelClicked="focusLabel"
          >
          </EditableSvg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { parse } from "node-html-parser";
import createDOMPurify from "dompurify";
import axios from "axios";
import EditableSvg from "./EditableSvg";
import TopBar from "./TopBar";
import FileLoader from "./FileLoader";

const svgns = "http://www.w3.org/2000/svg";

const modes = {
  POSTMESSAGE: "POSTMESSAGE",
  LOAD_FROM_URL: "LOAD_FROM_URL",
};

function isValidURL(string) {
  const res = string.match(
    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g
  );
  return res !== null;
}

// javascript js equivalent declaration:
// function getAttributeTransform_js(nativeSVGElement) {
// typescript ts declaration
// @see https://stackoverflow.com/questions/57955159/parse-svg-transform-attribute-with-typescript
function getAttributeTransform(nativeSVGElement) {
  const transformStr = nativeSVGElement.getAttribute("transform");
  // this definition works in ts and js
  const rect = document.createElementNS(svgns, "rect");
  rect.setAttribute("transform", transformStr);
  // Use the DOM to get the list of decoded transforms
  const tl = rect.transform.baseVal;
  const st = {};
  for (let i = 0; i < tl.numberOfItems; i++) {
    const t /*: SVGTransform*/ = tl.getItem(i);
    switch (t.type) {
      case SVGTransform.SVG_TRANSFORM_UNKNOWN:
        break;
      case SVGTransform.SVG_TRANSFORM_MATRIX: {
        // A matrix(…) transformation
        // Note: this is the most general transformation, capable of representing more transformations than the other combined.
        // For SVG_TRANSFORM_MATRIX, the matrix contains the a, b, c, d, e, f values supplied by the user.
        //
        // Note: instead of comma (,), whitespace separation would also be allowed
        st.matrix = {
          a: t.matrix.a,
          b: t.matrix.b,
          c: t.matrix.c,
          d: t.matrix.d,
          e: t.matrix.e,
          f: t.matrix.f,
        };
        break;
      }
      case SVGTransform.SVG_TRANSFORM_TRANSLATE: {
        // A translate(…) transformation
        // For SVG_TRANSFORM_TRANSLATE, e and f represent the translation amounts (a=1, b=0, c=0 and d=1).
        st.translate = {
          e: t.matrix.e,
          f: t.matrix.f,
        };
        break;
      }
      case SVGTransform.SVG_TRANSFORM_SCALE: {
        // A scale(…) transformation
        // For SVG_TRANSFORM_SCALE, a and d represent the scale amounts (b=0, c=0, e=0 and f=0).
        st.scale = {
          a: t.matrix.a,
          d: t.matrix.d,
        };
        break;
      }
      case SVGTransform.SVG_TRANSFORM_ROTATE: {
        // A rotate(…) transformation
        // For SVG_TRANSFORM_ROTATE, a, b, c, d, e and f together represent the matrix which will result in the given rotation.
        // When the rotation is around the center point (0, 0), e and f will be zero.
        /*
        angle   float   A convenience attribute for SVG_TRANSFORM_ROTATE, SVG_TRANSFORM_SKEWX and SVG_TRANSFORM_SKEWY. It holds the angle that was specified.

        For SVG_TRANSFORM_MATRIX, SVG_TRANSFORM_TRANSLATE and SVG_TRANSFORM_SCALE, angle will be zero.
        */
        /*
        This is the hardest case since the origin information is lost!
        We need to recompute it from the matrix.
        from https://math.stackexchange.com/questions/2093314/rotation-matrix-of-rotation-around-a-point-other-than-the-origin

        matrix.a = cos_angle = c;
        matrix.b = sin_angle = s;
        Note that by the laws of geometry: c^2+s^2 = 1 (c and s are coordinates on the unit circle)
        matrix.e = -x*c + y*s + x;
        matrix.f = -x*s - y*c + y;

        Using Mathematica/Wolfram Language:
        "Assuming[c^2+s^2==1,Solve[e == -x*c + y*s + x&& f == -x*s - y*c + y,{x,y},Reals]//Simplify]//InputForm"
        (you can use WL for free here: https://develop.wolframcloud.com/objects/c26e16f7-44e7-4bb6-81b3-bc07782f9cc5)
        {{x -> (e + (f*s)/(-1 + c))/2, y -> (f - c*f + e*s)/(2 - 2*c)}}
        */
        const e = t.matrix.e,
          f = t.matrix.f,
          c = t.matrix.a,
          s = t.matrix.b;
        const originx = (e + (f * s) / (-1 + c)) / 2;
        const originy = (f - c * f + e * s) / (2 - 2 * c);
        st.rotate = {
          angle: t.angle,
          x: originx,
          y: originy,
        };
        break;
      }
      case SVGTransform.SVG_TRANSFORM_SKEWX: {
        // A skewx(…) transformation
        // For SVG_TRANSFORM_SKEWX and SVG_TRANSFORM_SKEWY, a, b, c and d represent the matrix which will result in the given skew (e=0 and f=0).
        /*
        angle   float   A convenience attribute for SVG_TRANSFORM_ROTATE, SVG_TRANSFORM_SKEWX and SVG_TRANSFORM_SKEWY. It holds the angle that was specified.

        For SVG_TRANSFORM_MATRIX, SVG_TRANSFORM_TRANSLATE and SVG_TRANSFORM_SCALE, angle will be zero.
        */
        st.skewx = t.angle;
        break;
      }
      case SVGTransform.SVG_TRANSFORM_SKEWY: {
        // A skewy(…) transformation
        // For SVG_TRANSFORM_SKEWX and SVG_TRANSFORM_SKEWY, a, b, c and d represent the matrix which will result in the given skew (e=0 and f=0).
        /*
        angle   float   A convenience attribute for SVG_TRANSFORM_ROTATE, SVG_TRANSFORM_SKEWX and SVG_TRANSFORM_SKEWY. It holds the angle that was specified.

        For SVG_TRANSFORM_MATRIX, SVG_TRANSFORM_TRANSLATE and SVG_TRANSFORM_SCALE, angle will be zero.
        */
        st.skewy = t.angle;
        break;
      }
    }
  }
  return st; // instead of comma (,), whitespace separation is also allowed
}

export default {
  name: "HelloWorld",
  data() {
    return {
      receiveMode: "",
      open: false,
      searchTerm: "",
      svg: {
        content: "",
        textElements: [],
      },
      font: {
        minSize: 1,
        maxSize: 30,
        defaultSize: 10,
        changeFactor: 1,
        defaultFamily: "DejaVu Sans",
      },
      modal: {
        text: "",
        auxText: "",
        show: true,
      },
      listFontsBase: [
        "DIN Bold",
        "DIN Condensed Bold",
        "DIN",
        "DIN Italic",
        "DIN Condensed",
      ],
      listFonts: []
    };
  },
  methods: {
    init: async function() {
      if (window.opener) {
        this.receiveMode = modes.POSTMESSAGE;
      } else {
        const svgUri = new URL(location.href).searchParams.get("svg");
        if (svgUri && isValidURL(svgUri)) {
          this.receiveMode = modes.LOAD_FROM_URL;
        } else {
          this.receiveMode = modes.UPLOAD;
        }
      }

      if (this.receiveMode == modes.POSTMESSAGE) {
        this.modal.auxText = "Loading SVG from tab";
        this.$receiveMessage(this.receiveSvgPostMessage);
        this.$postMessage(
          "My body is ready",
          process.env.VUE_APP_TRUSTED_DOMAIN,
          window.opener
        );
      }

      if (this.receiveMode == modes.LOAD_FROM_URL) {
        const svgUri = new URL(location.href).searchParams.get("svg");
        try {
          this.modal.auxText = "Loading SVG from url";
          const response = await axios.get(svgUri);
          this.loadSvg(response.data);
          this.modal.show = false;
        } catch (e) {
          this.modal.auxText = "Could not load SVG from url";
          this.receiveMode = modes.UPLOAD;
        }
      }

      if (this.receiveMode == modes.UPLOAD) {
        this.modal.text = "Upload an SVG";
      }
    },
    loadSvgFromFile(text) {
      try {
        this.loadSvg(text);
        this.modal.show = false;
      } catch (e) {
        this.modal.auxText = "Could not read your SVG. Try another one";
      }
    },
    loadSvgFromBar(text) {
      this.modal.show = true;
      this.modal.auxText = "";
      this.modal.text = "Loading new SVG";
      try {
        this.loadSvg(text);
        this.modal.show = false;
      } catch (e) {
        this.modal.auxText = "Could not read your SVG. Try another one";
      }
    },
    receiveSvgPostMessage(event) {
      if (event.origin === process.env.VUE_APP_TRUSTED_DOMAIN) {
        this.loadSvg(event.data);
        this.modal.show = false;
        this.$receiveMessage(this.receiveSvgPostMessage, { remove: true });
      }
    },
    focusLabel(index) {
      const inputRef = `input${index}`;
      if (this.$refs[inputRef] && this.$refs[inputRef][0]) {
        this.$refs[inputRef][0].scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        this.$refs[inputRef][0].focus({ preventScroll: true });
      }
    },
    addNewLabel() {
      const CTM = document.getElementById("theG").getScreenCTM();
      const coord = {
        x: (500 - CTM.e) / CTM.a,
        y: (150 - CTM.f) / CTM.d,
      };
      const newIx = this.svg.textElements.length;
      if(!this.listFonts.includes(this.font.defaultFamily) && !this.listFonts.includes(`"${this.font.defaultFamily}"`)){
        this.listFonts.unshift(this.font.defaultFamily)
      }
      this.svg.textElements.push({
        index: newIx,
        text: "new label",
        x: coord.x,
        y: coord.y,
        highlighted: false,
        fontSize: this.font.defaultSize,
        fontFamily: this.font.defaultFamily,
      });
      setTimeout(() => this.focusLabel(newIx), 100);
    },
    loadSvg: function(text) {
      const DOMPurify = createDOMPurify(window);
      const cleanDOM = DOMPurify.sanitize(text, { ADD_TAGS: ["use"] });
      const dom = parse(cleanDOM);
      const svgDom = dom.querySelectorAll("svg")[0];
      const that = this;

      that.listFonts = [...that.listFontsBase];

      svgDom.setAttribute("id", "theSvg");
      svgDom.setAttribute("width", "100%");
      svgDom.setAttribute("height", "100%");

      const topGs = svgDom.querySelectorAll("g");
      if (topGs.length > 1) {
        const newTopG = parse(`<g id="theG"></g>`).querySelectorAll("g")[0];
        topGs.forEach((g) => {
          newTopG.appendChild(g);
          svgDom.removeChild(g);
        });
        svgDom.appendChild(newTopG);
      } else {
        topGs[0].setAttribute("id", "theG");
      }

      function removeClipPathAttribute(node) {
        node.removeAttribute("clip-path");
        const subgs = node.querySelectorAll("g");
        subgs.forEach((subg) => {
          removeClipPathAttribute(subg);
        });
      }

      const gs = svgDom.querySelectorAll("g");
      gs.forEach((g) => {
        removeClipPathAttribute(g);
      });

      const defs = svgDom.querySelectorAll("defs");
      defs.forEach((def) => {
        const styles = def.querySelectorAll("style");
        if (styles.length) {
          def.set_content("");
        }
      });

      function getTextElementX(element) {
        const numX =
          element.getAttribute("x") || parseInt(element.getAttribute("dx"));
        if (numX) {
          return numX;
        }
      }

      function getTextElementY(element) {
        const numY =
          element.getAttribute("y") || parseInt(element.getAttribute("dy"));
        if (numY) {
          return numY;
        }
      }

      function processTextElement(textElement) {
        const ix = that.svg.textElements.length;

        // Properties that will always(?) be there

        // Text will always be there

        const dynamicProperties = {
          index: ix,
          text: textElement.innerHTML,
          highlighted: false,
        };

        let dynamicClassString = `{highlighted: elements[${ix}].highlighted`;

        textElement.set_content(`{{elements[${ix}].text}}`);

        // Try getting the fontsize

        let fontSize = textElement.getAttribute("font-size");
        let fontFamily = textElement.getAttribute("font-family");

        const styleAttr = textElement.getAttribute("style");
        if (styleAttr) {
          const propsToRemove = [
            "font-size",
            "font-family",
            "font-style",
            "text-anchor",
          ];
          let styleString = "";
          styleAttr.split(";").forEach((propString) => {
            const propEntry = propString.trim().split(":");
            if (propEntry[0] === "font-size") {
              fontSize = propEntry[1]; // Found it!
            }
            if (propEntry[0] === "font-family") {
              fontFamily = propEntry[1]; // Found it!
            }
            if (propEntry[0] && !propsToRemove.includes(propEntry[0])) {
              styleString = `${propString.replace(/"/g, "'")}; ${styleString}`;
            }
          });
          textElement.setAttribute("style", styleString);
        }
        
        if (fontFamily && !that.listFonts.includes(fontFamily) && !that.listFonts.includes(fontFamily.replaceAll('"',''))) {
          that.listFonts.unshift(fontFamily);
        }

        dynamicProperties.fontSize = parseInt(fontSize) || that.font.defaultSize;
        dynamicProperties.fontFamily = fontFamily || that.font.defaultFamily;
        
        textElement.removeAttribute("font-size");
        textElement.setAttribute(":font-size", `getFontSize(elements[${ix}])`);

        textElement.removeAttribute("font-family");
        textElement.setAttribute(
          ":font-family",
          `getFontFamily(elements[${ix}])`
        );

        // Properties that won't always be there.
        // TODO get and use absolute x, y when positioning with transform(translate)

        let x = getTextElementX(textElement);
        let y = getTextElementY(textElement);

        if (x !== undefined && y === undefined) {
          y = 0;
        }

        if (x === undefined && y !== undefined) {
          x = 0;
        }

        if (x !== undefined) {
          dynamicProperties.x = x;
          textElement.removeAttribute("x");
          textElement.setAttribute(":x", `elements[${ix}].x`);
        }

        if (y !== undefined) {
          dynamicProperties.y = y;
          textElement.removeAttribute("y");
          textElement.setAttribute(":y", `elements[${ix}].y`);
        }

        try {
          const transformAttrs = getAttributeTransform(textElement);
          if (transformAttrs) {
            if (x === undefined && y === undefined) {
              textElement.removeAttribute("transform");
              dynamicProperties.x = transformAttrs.translate.e;
              dynamicProperties.y = transformAttrs.translate.f;

              if (transformAttrs.rotate) {
                const { angle } = transformAttrs.rotate;
                textElement.setAttribute(
                  ":transform",
                  `'rotate(${angle}, ' + elements[${ix}].x + ', ' + elements[${ix}].y + ')'`
                );
              }

              textElement.setAttribute(":x", `elements[${ix}].x`);
              textElement.setAttribute(":y", `elements[${ix}].y`);
            }
            if (x !== undefined && y !== undefined) {
              textElement.removeAttribute("transform");
              if (transformAttrs.rotate) {
                const { angle } = transformAttrs.rotate;
                textElement.setAttribute(
                  ":transform",
                  `'rotate(${angle}, ' + elements[${ix}].x + ', ' + elements[${ix}].y + ')'`
                );
              }
            }
          }
        } catch (e) {
          x = undefined;
        }

        if (
          dynamicProperties.x !== undefined &&
          dynamicProperties.y !== undefined
        ) {
          textElement.setAttribute("@mousedown", `startDrag($event, ${ix})`);
          textElement.setAttribute("@mouseup", `drop($event, ${ix})`);
          dynamicClassString = `${dynamicClassString}, 'cursor-move': true`;
        }

        that.svg.textElements.push(dynamicProperties);

        textElement.setAttribute(
          "@dblclick",
          `emitLabelDoubleClick($event, ${ix})`
        );
        textElement.setAttribute(":class", `${dynamicClassString}}`);
        textElement.setAttribute("id", `editable_text_${ix}`);
      }

      this.svg.textElements = [];

      const texts = svgDom.querySelectorAll("text");
      const tspans = [];
      texts.forEach((textElement, index) => {
        const tSpans = textElement.querySelectorAll("tspan");
        if (tSpans.length) {
          tSpans.forEach((span) => {
            tspans.push(span);
          });
          return;
        }
        processTextElement(textElement, index);
      });

      tspans.forEach(processTextElement);

      // Try rendering 'added' texts

      const mainG = svgDom.querySelector("g");
      const textTag = `
      <text
        v-for="element in elements.slice(${this.svg.textElements.length})"
        :font-size="getFontSize(element)"
        :font-family="getFontFamily(element)"
        :x="element.x"
        :y="element.y"
        :id="getIdNewLabel(element.index)"
        @mousedown="startDrag($event, element.index)"
        @mouseup="drop($event, element.index)"
        @dblclick="emitLabelDoubleClick($event, element.index)"
        :class="{highlighted: element.highlighted, 'cursor-move': true}"
      >
        {{element.text}}
      </text>`;
      const textNode = parse(textTag).querySelector("text");
      mainG.appendChild(textNode);

      this.svg.content = svgDom.toString();
    },
    changeFont(fontFamily, index) {
      if (index !== undefined) {
        this.setNewFont(fontFamily, index);
      } else {
        this.svg.textElements.forEach((textElement, index) => {
          this.setNewFont(fontFamily, index);
        });
      }
    },
    setNewFont(fontFamily, index) {
      this.svg.textElements[index].fontFamily = fontFamily;
    },
    enlargeText(index) {
      this.addToFontSize(this.font.changeFactor, index);
    },
    shrinkText(index) {
      this.addToFontSize(-1 * this.font.changeFactor, index);
    },
    addToFontSize(value, index) {
      if (index !== undefined) {
        const newFontsize = this.svg.textElements[index].fontSize + value;
        this.setElementFontsize(index, newFontsize);
      } else {
        this.svg.textElements.forEach((textElement, index) => {
          const newFontsize = textElement.fontSize + value;
          this.setElementFontsize(index, newFontsize);
        });
      }
    },
    setElementFontsize(index, newFontsize) {
      if (
        newFontsize >= this.font.minSize &&
        newFontsize <= this.font.maxSize
      ) {
        this.svg.textElements[index].fontSize = newFontsize;
      }
    },
    deleteText(index) {
      var t = document.createElement("template");
      t.innerHTML = this.svg.content;
      const svgLikeCode = t.content.firstChild;
      const elem =
        svgLikeCode.querySelector(`[id=editable_text_${index}]`) ||
        document.querySelector(`[id=editable_text_${index}]`);
      if (elem) {
        elem.remove();
      }
      this.svg.content = svgLikeCode.outerHTML;
      const copyElements = [...this.svg.textElements];
      copyElements[index] = {};
      this.svg.textElements = copyElements;
    },
  },
  computed: {
    displayedTextElements() {
      if (this.searchTerm === "") {
        return this.svg.textElements;
      } else {
        return this.svg.textElements.filter(
          (element) =>
            element.highlighted ||
            element.text?.toLowerCase().includes(this.searchTerm.toLowerCase())
        );
      }
    },
  },
  components: {
    EditableSvg,
    FileLoader,
    TopBar,
  },
  created() {
    this.init();
  },
};
</script>

<style scoped lang="stylus">
#content
  max-height calc(100% - 48px)

h3
  margin 40px 0 0

ul
  list-style-type none
  padding 0

li
  display inline-block
  margin 0 10px

.dropdown:hover .dropdown-menu {
  display: grid;
  left: 50% !important;
  right: auto !important;
  transform: translate(-50%, 0) !important;
}
.link-ellipsis {
  display: block; width: 230px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.height-buttons {
  height: 28px;
}
</style>
